import { styled } from "@linaria/react";
import classNames from "classnames";
import React from "react";
import { color, fonts } from "..";
import { HIDE_ON_EXPORT } from "../lib/downloadPage";
import t from "../i18n";
import { CloseLine } from "../IconV2/react";
import { spacings } from "../Theme";

export const ResetElement = styled.div`
  font: ${fonts.body2};
  font-weight: 500;
  opacity: 0.5;
  color: ${color.lightNitrogen500_Main};
  display: flex;
  align-items: center;
  gap: ${spacings.xxs};
  :hover {
    cursor: pointer;
  }
  &.active {
    opacity: 1;
    :hover {
      text-decoration: underline;
    }
  }
`;

interface P<FilterValues extends { [k: string]: (string | null)[] }> {
  icon?: boolean;
  filterValues: FilterValues;
  setFilterValues: (filterValues: FilterValues) => void;
  defaultFilterValues: FilterValues;
}

function Reset<FilterValues extends { [k in keyof FilterValues]: (string | null)[] }>({
  icon = false,
  filterValues,
  setFilterValues,
  defaultFilterValues,
}: P<FilterValues>) {
  const resetFilterValues = React.useCallback(
    () => setFilterValues(defaultFilterValues),
    [defaultFilterValues, setFilterValues],
  );

  const keys = Object.keys(filterValues) as (keyof FilterValues)[];

  return (
    <ResetElement
      onClick={resetFilterValues}
      className={classNames(
        {
          active: keys.some(k => filterValues[k].length),
        },
        HIDE_ON_EXPORT,
      )}
    >
      {icon && <CloseLine size="s" />}
      {t("filter.reset")}
    </ResetElement>
  );
}

export default Reset;
